module.exports = __webpack_public_path__ + "img/symbol.d8e0646a.gif";